import React, { useState } from "react";
import { Transition } from "react-transition-group";
import cx from "clsx";

import globalStyles from "@/styles/global.module.scss";
import styles from "./stopPoint.module.scss";

const StopPoint = props => {
  const {
    delayMs = 0,
    visible,
    top,
    left,
    tooltip,
    className,
    onStopClick,
    renderChild,
    buttonClassName
  } = props;

  const [isHovered, setHovered] = useState(false);
  const handleMouse = val => () => setHovered(val);

  return (
    <div
      className={styles.container}
      style={{
        top: `${top}%`,
        left: `${left}%`
      }}
    >
      <div className={styles.inner}>
        <button
          className={cx(
            globalStyles.buttonReset,
            styles.button,
            buttonClassName
          )}
          style={{ cursor: !visible ? "default" : "pointer" }}
          onMouseEnter={handleMouse(true)}
          onMouseLeave={handleMouse(false)}
          onClick={onStopClick}
        >
          <Transition enter exit in={visible} timeout={0}>
            {state => {
              return (
                <div
                  className={cx(
                    styles.point,
                    styles.nodeAnimation,
                    styles[state],
                    className
                  )}
                  style={{
                    transitionDelay: `${state === "exiting" ? 0 : delayMs}ms`
                  }}
                >
                  {renderChild({ isHovered })}
                </div>
              );
            }}
          </Transition>
        </button>
        {tooltip ? (
          <div className={styles.tooltipContainer}>
            <Transition enter exit in={isHovered} timeout={0}>
              {state => {
                return (
                  <div
                    className={cx(
                      styles.tooltipInner,
                      styles.tooltipAnimation,
                      styles[state]
                    )}
                  >
                    <span className={styles.tooltip}>{tooltip}</span>
                  </div>
                );
              }}
            </Transition>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default StopPoint;
